<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <Dialog :id="uniqueid" titulo="Lancar Plano" ref="dialog" :modal="true" :hideHeader="true" :tamanho="'lg'">

        <h2>Pay</h2>

        <ListPayAdminItem class="m-2 pl-0 list-group-item" :item="payItem" propView="simple" />

        <ListUsuarios ref="listUsuario" :view="'select'" @selectItemChange="usuarioChange" :itensLimit="5"/>

        <EditPlanoCliente ref="editPlanoCliente" propHideFooter="true" :createuniqueid="true" propView="document" :class="{'d-none': usuario == null}" @salvou="fechar()" @erro="$refs.buttonSalvarPlano.disabled=false;" />

        <template v-slot:rodape>
          <div class="row">
            <div class="col-md-12 col-sm-12 d-flex justify-content-center text-center">
              <button type="button" class="btn btn-secondary" @click="fechar()">
                Cancelar
              </button>
              <button ref="buttonSalvarPlano" type="button" :class="{'d-none': usuario == null}" class="btn btn-primary btn-sm" style="margin-left: 10px"
                @click="salvar()">
                Salvar plano
              </button>
            </div>
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
//import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import ListUsuarios from "../lists/ListUsuarios";
import EditPlanoCliente from "../edits/EditPlanoCliente.vue";
import ListPayAdminItem from "../lists/ListPayAdminItem.vue";

export default {
  name: "DialogPlanoCliente",
  components: { Dialog, ListUsuarios, EditPlanoCliente, ListPayAdminItem },
  props: {
    propUsuario: { type: String, default: "" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-12"];
      },
    },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    fechar() {
      this.$refs.dialog.fechar();
      this.$emit("fechar");
    },
    abrir() {

      this.usuario = null;
      this.$refs.buttonSalvarPlano.disabled=false;
      this.$refs.dialog.abrir();
      this.$refs.listUsuario.limpar();

    },
    salvar() {

      this.$refs.buttonSalvarPlano.disabled=true;
      this.$refs.editPlanoCliente.salvar();
      
    },
    usuarioChange(usuario){
      this.usuario = usuario;

      if(this.usuario !== null)
      {
        this.$refs.editPlanoCliente.carregarItem(usuario, {pp: this.payItem._id, comprovante: this.payItem.regexComprovante ? this.payItem.regexComprovante : ''});
      }

    }
  },
  async mounted() {
    this.uniqueid = 'dialogListPlanoCliente_' + util.guidGenerator();
  },
  data: function () {
    return {
      uniqueid: "",
      usuario: null,
      payItem: {}
    };
  },
  computed: {},
};
</script>

<style></style>
